'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

var _UISearchInput = require('UIComponents/input/UISearchInput');

var _UISearchInput2 = _interopRequireDefault(_UISearchInput);

var _UIHeader = require('UIComponents/layout/UIHeader');

var _UIHeader2 = _interopRequireDefault(_UIHeader);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITable = require('UIComponents/table/UITable');

var _UITable2 = _interopRequireDefault(_UITable);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _reactRouterDom = require('react-router-dom');

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Users = function (_Component) {
  _inherits(Users, _Component);

  function Users(props) {
    _classCallCheck(this, Users);

    var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this, props));

    _this.update = _this.update.bind(_this);
    return _this;
  }

  _createClass(Users, [{
    key: 'update',
    value: function update(evt) {
      this.props.search(evt.target.value);
    }
  }, {
    key: 'renderRow',
    value: function renderRow(user) {
      var company = null;
      if (user.company) {
        if (user.companyWebsite) {
          company = _react2.default.createElement(
            _UILink2.default,
            { href: user.companyWebsite },
            user.company
          );
        } else {
          company = _react2.default.createElement(
            'span',
            null,
            user.company
          );
        }
      }
      var subheading = null;
      if (user.jobTitle) {
        if (company) {
          subheading = _react2.default.createElement(
            _UITruncateString2.default,
            null,
            user.jobTitle,
            ' at ',
            company
          );
        } else {
          subheading = _react2.default.createElement(
            _UITruncateString2.default,
            null,
            user.jobTitle
          );
        }
      } else if (company) {
        subheading = _react2.default.createElement(
          _UITruncateString2.default,
          null,
          company
        );
      }
      var link = user.username ? user.username : 'users/' + user.id;
      return _react2.default.createElement(
        'tr',
        { key: user.id },
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'cell-wrap' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: link, className: 'avatar' },
              _react2.default.createElement(_UISimpleAvatar2.default, { src: user.avatarUrl + '/48', size: 'md' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'headline' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: link },
                  user.firstName + ' ' + user.lastName
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _Small2.default,
                  { use: 'help' },
                  subheading
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderRows',
    value: function renderRows() {
      var that = this;
      return this.props.users.map(function (user) {
        return that.renderRow(user);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _NavApp2.default,
        null,
        _react2.default.createElement(
          'div',
          { className: 'users-page' },
          _react2.default.createElement(
            'div',
            { className: 'search' },
            _react2.default.createElement(_UISearchInput2.default, { use: 'on-dark', minimumSearchCount: 3, onChange: this.update })
          ),
          _react2.default.createElement(_UIHeader2.default, { title: 'Members', use: 'condensed', className: 'header' }),
          _react2.default.createElement(
            _UITable2.default,
            { truncated: true },
            _react2.default.createElement(
              'tbody',
              null,
              this.renderRows()
            )
          )
        )
      );
    }
  }]);

  return Users;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var users = _ref.users;

  return { users: users };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  search: function search(term) {
    return (0, _actions.createAction)(_actions2.default.USERS_ASK, term);
  }
})(Users);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/Users.js
// module id = 362
// module chunks = 0